module.exports = __webpack_public_path__ + "media/flags/cr-79a1512a.svg";